import { put, takeLatest, call } from 'redux-saga/effects';
import axios from 'axios';
import { SAVE_USER_MEAL_PLAN, GET_USER_MEAL_PLAN } from './constants';
import {
  saveUserMealPlanSuccess,
  saveUserMealPlanError,
  getUserMealPlanSuccess,
  getUserMealPlanError,
} from './actions';
import { normalizeError } from '../../helpers/utils';

export function* getUserMealPlan() {
  try {
    const payload = yield call(axios.get, '/api/mealPlan/user-meal-plan');
    yield put(getUserMealPlanSuccess(payload.data));
  } catch (err) {
    const errors = normalizeError(err);
    console.log(errors);
    yield put(getUserMealPlanError(errors));
  }
}

export function* saveUserMealPlan({ mealPlan, callback }) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const body = JSON.stringify(mealPlan);
  try {
    const payload = yield call(
      axios.post,
      '/api/mealPlan/user-meal-plan',
      body,
      config
    );
    // ✅ Call the callback with the saved mealPlan ID
    if (callback) {
      callback(payload.data._id);
    }
    yield put(saveUserMealPlanSuccess(payload.data));
  } catch (err) {
    const errors = normalizeError(err);
    console.log(errors);
    yield put(saveUserMealPlanError(errors));
  }
}

export default function* mealPlanSaga() {
  yield takeLatest(SAVE_USER_MEAL_PLAN, saveUserMealPlan);
  yield takeLatest(GET_USER_MEAL_PLAN, getUserMealPlan);
}
